import type { SongToneAnalysis } from '../../models/toneAnalysis'
import type { DemoSourceSummary } from '../../models/demoToneAnalysis'
import { GuitarTrackCard } from './GuitarTrackCard'
import { ToneSceneCard } from './ToneSceneCard'
import { ToneTimeline } from './ToneTimeline'

type ToneAnalysisResultsProps = {
  analysis: SongToneAnalysis
  sourceSummary: DemoSourceSummary | null
  onAnalyzeAnother: () => void
}

export function ToneAnalysisResults({ analysis, sourceSummary, onAnalyzeAnother }: ToneAnalysisResultsProps) {
  return <div className="ts-analysis-results">
    <div className="ts-analysis-summary">
      <span className="ts-demo-badge">SONG TONE ANALYSIS</span>
      <div>
        <h3>{analysis.songTitle}</h3>
        <p>{analysis.artist || 'Unknown artist'} - {analysis.presetBaseName}</p>
        {sourceSummary?.name && <small>{sourceSummary.type}: {sourceSummary.name}</small>}
      </div>
      <div className="ts-analysis-summary-grid">
        <div><span>Guitar tracks</span><b>{analysis.guitarTracks.length}</b></div>
        <div><span>Tone scenes</span><b>{analysis.toneScenes.length}</b></div>
      </div>
    </div>

    <ToneTimeline tracks={analysis.guitarTracks} toneScenes={analysis.toneScenes}/>

    <div className="ts-analysis-results-grid">
      <section>
        <h4>Guitar tracks</h4>
        <div className="ts-analysis-card-list">
          {analysis.guitarTracks.map((track) => <GuitarTrackCard key={track.id} track={track} toneScenes={analysis.toneScenes}/>)}
        </div>
      </section>

      <section>
        <h4>Tone scenes</h4>
        <div className="ts-analysis-card-list">
          {analysis.toneScenes.map((scene) => <ToneSceneCard key={scene.id} scene={scene}/>)}
        </div>
      </section>
    </div>

    <div className="ts-analysis-actions">
      <button className="button ghost" type="button" onClick={onAnalyzeAnother}>Analyze another song</button>
      <button
        className="button"
        type="button"
        disabled
        aria-label="Generate Helix Preset - Coming soon"
      >
        Generate Helix Preset - Coming soon
      </button>
    </div>
  </div>
}
